var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M2.268 0C.9 0 0 .933 0 2.167c0 1.2.867 2.165 2.2 2.165 1.434 0 2.334-.965 2.3-2.165C4.5.933 3.634 0 2.268 0m12.798 5.733c-2.3 0-3.7 1.333-4.266 2.266h-.066l-.2-1.966h-3.7c.033 1.267.1 2.733.1 4.467v9.498H11.2v-8.033c0-.4.033-.8.133-1.1.333-.8 1.034-1.633 2.2-1.633 1.567 0 2.167 1.234 2.167 3.034v7.732H20v-8.232c0-4.133-2.134-6.033-4.934-6.033m-14.965.3v13.965h4.266V6.033z"
})));
export default SvgLinkedin24;